<template>
  <form @submit.prevent="handleSubmit" id="category_edit_form">
    <!-- Category Name -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Category Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="edit_name" name="name" ref="name"
        v-model="form.name" placeholder="Category Name" />
    </div>

    <!-- Description -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Description If Any</label>
      <textarea class="form-control form-control-thin" id="edit_description" name="description" ref="description"
        v-model="form.description" placeholder="Category Description" rows="2"></textarea>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-danger btn-sm hover-white" @click="close" :disabled="submitting">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary text-light hover-white btn-md form-submit-btn" :disabled="submitting">
        <span v-if="submitting" class="spinner-border spinner-border-sm me-1" role="status"></span>
        <i v-else class="fa fa-save me-1"></i>
        {{ submitting ? 'Updating...' : 'Update Category' }}
      </button>
    </div>
  </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'

export default {
  name: 'EditWOCategory',
  emits: ['updated', 'close'],
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        external_id: null
      },
      submitting: false,
      categoryId: null
    }
  },
  watch: {
    category: {
      immediate: true,
      handler(category) {
        if (category) {
          this.categoryId = category.id
          this.form.external_id = category.external_id
          this.form.name = category.name || ''
          this.form.description = category.description || ''
        }
      }
    }
  },
  methods: {
    resetForm() {
      this.categoryId = null
      this.form = {
        name: '',
        description: '',
        external_id: null
      }
    },

    async handleSubmit() {
      if (!this.categoryId) {
        this.$toast('Invalid category ID', false)
        return
      }

      this.submitting = true

      try {
        const result = await form_api_submit({
          url: 'wo/category/update/' + this.categoryId,
          method: 'POST',
          data: this.form,
          curr_form_id: '#category_edit_form',
        })

        if (result.success) {
          this.resetForm()
          this.$emit('updated', result.data.category)
        }
      } catch (error) {
        console.error('Error updating category:', error)
        this.$toast('Failed to update category', false)
      } finally {
        this.submitting = false
      }
    },

    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.form-label-thin {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  margin-bottom: 4px;
}

.form-control-thin {
  font-size: 13px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1.5px solid #e0e0e0;
  transition: border-color 0.2s;
}

.form-control-thin:focus {
  border-color: #667eea;
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #fafbfc;
  border-radius: 0 0 12px 12px;
}

.spinner-border-sm {
  width: 16px;
  height: 16px;
  border-width: 2px;
}
</style>